import React from "react";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { Button } from "@aidkitorg/component-library";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { createStagedComponent } from "@aidkitorg/types/lib/admin-panel/dashboard";
import { useBarChartFormState } from "../hooks/useBarChartFormState";
import { BarChartFormFields } from "./BarChartFormFields";
import { useLocalizedStrings } from "../../../Localization";

export const BarChartComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode, onClose }) => {
  const L = useLocalizedStrings()

  const {
    title, setTitle,
    description, setDescription,
    xAxis, setXAxis,
    yAxis, setYAxis,
    filterConfig, setFilterConfig,
    buildBarChartObject,
    isFormStateValid
  } = useBarChartFormState()

  const {
    setStagedComponents,
    getDashboardComponentTranslation
  } = useDashboards()

  const saveBarChartComponent = async () => {
    const newBarChart = buildBarChartObject()

    const translations = await getDashboardComponentTranslation(newBarChart)

    if (translations && translations.success) {
      const stagedComponent = createStagedComponent(newBarChart, translations.data)
      setStagedComponents((prev) => ([...prev, stagedComponent]))
      setDisplayMode('create')
      onClose?.()
    } else {
      console.error('Failed to translate bar chart component:', newBarChart)
      // TODO: Show user-friendly error message
    }
  }

  return (
    <div className="flex flex-col gap-y-2">
      <BarChartFormFields
        title={title}
        setTitle={setTitle}
        description={description}
        setDescription={setDescription}
        xAxis={xAxis}
        setXAxis={setXAxis}
        yAxis={yAxis}
        setYAxis={setYAxis}
        filterConfig={filterConfig}
        setFilterConfig={setFilterConfig}
      />
  
      <div className="flex justify-between gap-x-2 pt-2">
        <Button onClick={() => setDisplayMode('create')} className="!w-1/2" variant="secondary">{L.admin_panel.dashboards.cancel}</Button>
        <Button isDisabled={!isFormStateValid} onClick={saveBarChartComponent} className="!w-1/2">{L.admin_panel.dashboards.save}</Button>
      </div>
    </div>
  )
}